import { Form } from '@/ui'
import { useTheme } from '@/hooks'
import { OptionWrapper, OptionLabel } from './Styles'
import FlexRow from '@/ui/FlexRow'
import { Checkbox } from 'semantic-ui-react'
import { Dispatch, ReactNode, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

interface OptionProps {
  checked?: boolean
  disabled?: boolean
  label: string | ReactNode
  onChange: (value: any) => void
  showTags?: boolean
  setExcluded?: Dispatch<SetStateAction<string[]>>
  excluded?: any[]
  id?: string
}

const Option = ({
  checked,
  disabled,
  label,
  onChange,
  showTags,
  setExcluded,
  excluded,
  id,
}: OptionProps) => {
  const { primaryColor, secondaryFontColor } = useTheme()
  const { t } = useTranslation()

  return (
    <FlexRow
      noMargin
      style={{ paddingBottom: showTags ? '10px' : '0' }}
      justifyContent="space-between"
      alignItems="center">
      <OptionWrapper
        onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          if (!disabled) {
            e.stopPropagation()
            onChange(id)
          }
        }}>
        {!disabled && (
          <Form.Checkbox
            action
            actionColor={primaryColor}
            actionColorContrast={secondaryFontColor}
            checked={checked}
          />
        )}

        <OptionLabel>{label}</OptionLabel>
      </OptionWrapper>

      {checked && showTags && (
        <OptionWrapper alignRight>
          <Checkbox
            checked={excluded?.includes(id)}
            onChange={() => {
              if (setExcluded && id) {
                if (excluded && excluded.includes(id)) {
                  setExcluded(prevState =>
                    prevState.filter(item => item !== id),
                  )
                }
                if (excluded && !excluded.includes(id)) {
                  setExcluded(prevState => [...prevState, id])
                }
              }
            }}
            toggle
            id={id}
          />
          <OptionLabel htmlFor={id}>{t('Exclude')}</OptionLabel>
        </OptionWrapper>
      )}
    </FlexRow>
  )
}

export default Option
